/* eslint-disable no-undef */
import { createIO } from '../../utils/io';

export class ShowHeading {
  constructor(el) {
    this.$el = el;

    this.#init();
  }

  #init() {
    const { words, chars } = new SplitText(this.$el, { type: 'words,chars' });

    gsap.set(chars, {
      opacity: 0,
      yPercent: -25,
      rotationX: -15
    });

    const io = createIO({
      rootMargin: '0px 0px -25% 0px'
    });

    const observer = io.observe(this.$el, (entry) => {
      if (entry.isIntersecting) {
        observer.remove();

        gsap.to(chars, {
          duration: 1.475,
          opacity: 1,
          yPercent: 0,
          rotationX: 0,
          ease: 'expo',
          stagger: 0.04
        });
      }
    });
  }
}
